import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export const reportsDialogCss = makeStyles((theme) => ({

    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    dialogTitleV1: {
        paddingLeft: 30, paddingTop: 10, paddingBottom: '10px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    },
    paper1: {
        borderRadius: 4,
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'none',
        fontWeight: 300,
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 8,
        paddingBottom: 9,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    cancelButton: {
        textTransform: 'none', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 8, paddingBottom: 9,
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    paperWidth: {
        maxWidth: 512
    },
    fwV1: {
        fontWeight: 300
    },
    dialogContentV1: {
        backgroundColor: '#f1f1f3', paddingLeft: 24, paddingRight: 24, height: '787px'
    },
    mtV1: {
        marginTop: 16
    },
    divV2: {
        backgroundColor: '#e4e4e4', border: '7px solid white', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '-webkit-fill-available', marginTop: 16
    },
    daV1: {
        paddingRight: 24, paddingTop: 21, paddingBottom: 21
    },
    daV2: {
        paddingRight: 24, paddingTop: 21, paddingBottom: 21, backgroundColor: '#f1f1f3'
    },
    pdfContainer: {
        height: "calc(100vh - 250px)",
        border: "1px solid grey",
        borderRadius: 4,
        marginTop: 16,
        backgroundColor: "#fff"
    },
    pdfSubContainer: {
        height: "calc(100vh - 268px)",
        overflowY: 'auto',
        margin: 8,
        border: "1px solid grey",
        borderRadius: 4,
        backgroundColor: '#E8E8E8'
    },
    filterButton: {
        backgroundColor: "#fff",
        margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px"
    },
    mlV1: {
        marginLeft: 10
    },
    divV1: {
        display: 'flex'
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(1.7)",
        color: "#c7c7c7"
    },
    vehicleNumber: {
        fontSize: 14,
        fontWeight: 500,
        marginLeft: 16
    },
    truckType: {
        fontSize: 14,
        fontWeight: 500,
        textTransform: 'capitalize'
    },
    vehicleNumberSuffix: {
        color: '#0033cc'
    },
    vehicleNumberReport: {
        fontSize: 14,
        color: '#0b1323',
        '&:last-child': {
            color: '#2c5de5',
            marginLeft: 6
        }
    },
    mlV2: {
        marginLeft: 16,
        letterSpacing: '0px !important'
    },
    excelButton: {
        textTransform: 'capitalize',
        backgroundImage: 'linear-gradient(#f6f7f9, #ffffff)',
        fontSize: 14,
        color: '#3e3f42',
        fontWeight: 300,
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 8,
        paddingBottom: 9,
        marginRight: 16,
        '&:hover': {
            backgroundImage: 'linear-gradient(#f6f7f9, #ffffff)',
        }
    },
    anchorV1: {
        color: "#fff", 
        textDecoration: 'none !important'
    },
    mlV2: {
        marginLeft: 8
    },
    divAlign: {
        display: 'flex',
        marginTop: 16
    }
}));